export default "__VITE_ASSET__c2e6d0aa__"